import React from "react";
import { Page, Text, Input, Button, Spacer, Card, useTheme } from "@geist-ui/core";

export default function RegistrationScreenshot() {
  const theme = useTheme();

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh', 
      background: '#fff', 
      padding: '40px 32px',
      fontFamily: '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200;300;400;600;700;800;900&display=swap');
      `}</style>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
         <div style={{ marginBottom: '60px' }}>
            <Text span style={{ 
                fontSize: '11px', 
                fontWeight: 600, 
                letterSpacing: '0.2em', 
                textTransform: 'uppercase', 
                color: '#888',
                display: 'block',
                marginBottom: '16px'
            }}>
                Exklusiver Zugang
            </Text>
            <Text h1 style={{ 
                fontSize: '48px', 
                fontWeight: 800, 
                letterSpacing: '-0.04em', 
                margin: 0, 
                lineHeight: 1,
                color: '#000',
                fontFamily: '"Nunito Sans", sans-serif'
            }}>
                Mitglied <br/> werden.
            </Text>
         </div>

         <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
             <div>
                <Text span style={{ fontSize: '12px', fontWeight: 600, color: '#000', marginBottom: '8px', display: 'block' }}>E-MAIL ADRESSE</Text>
                <div style={{ borderBottom: '1px solid #eaeaea', padding: '8px 0' }}>
                    <Text p style={{ margin: 0, fontSize: '18px', fontWeight: 500, color: '#000', filter: 'blur(8px)', userSelect: 'none' }}>max.mustermann@venture.com</Text>
                </div>
             </div>
             
             <div>
                 <Text span style={{ fontSize: '12px', fontWeight: 600, color: '#000', marginBottom: '8px', display: 'block' }}>PASSWORT FESTLEGEN</Text>
                 <div style={{ borderBottom: '1px solid #eaeaea', padding: '8px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                     <Text p style={{ margin: 0, fontSize: '18px', fontWeight: 500, color: '#000' }}>••••••••••••</Text>
                 </div>
             </div>
         </div>
      </div>

      <div>
          <Button width="100%" scale={1.25} style={{ 
              background: '#000', 
              color: '#fff', 
              border: 'none', 
              borderRadius: '100px', 
              height: '64px',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
          }}>
              Account erstellen
          </Button>
          <Spacer h={1} />
          <Text p style={{ textAlign: 'center', fontSize: '11px', color: '#999', margin: 0 }}>
              Durch die Registrierung akzeptieren Sie unsere <span style={{ textDecoration: 'underline', color: '#000' }}>Servicebedingungen</span>.
          </Text>
      </div>
    </div>
  );
}
